const configuredServerUrl = process.env.REACT_APP_SERVER || '';

const getServerUrl = () => {
  if (typeof window === 'undefined' || !configuredServerUrl) return configuredServerUrl;

  try {
    const serverUrl = new URL(configuredServerUrl);
    const serverIsLocal = serverUrl.hostname === 'localhost' || serverUrl.hostname === '127.0.0.1';
    const siteIsOpenedRemotely = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

    if (serverIsLocal && siteIsOpenedRemotely) {
      serverUrl.hostname = window.location.hostname;
      return serverUrl.toString().replace(/\/$/, '');
    }

    return configuredServerUrl.replace(/\/$/, '');
  } catch {
    return configuredServerUrl.replace(/\/$/, '');
  }
};

export const URL_PROXY = getServerUrl();
